import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { Redirect } from 'react-router-dom';
import PickUpPointsAddOrUpdate from "./HubPickUpPointsAddOrUpdate";
import { showNotification, successNofication } from "src/shared/components/Notification";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";

const HubPickUpPointsDetailsModal = ({ modalShow, setModalShow, isTitle, dataInfo }) => {

    const [isRedirect, setIsRedirect] = useState(false);
    const [isMapData, setMapData] = useState(null);
    const [isLatitude, setLatitude] = useState(null);
    const [isLongitude, setLongitide] = useState(null);

    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

    if (isRedirect) {
        window.location.reload();
        return <Redirect to={`/web_app/hub_pick_up_point/view`} />;
    }
    const handleSubmit = async (formValues) => {
        try {
            formValues["pickUpPointAddress"] = isMapData ? isMapData : dataInfo?.pickUpPointAddress;
            formValues["latitude"] = isLatitude ? isLatitude : dataInfo?.latitude;
            formValues["longitude"] = isLongitude ? isLongitude : dataInfo?.longitude;

            const response = await PndRestApi.AddOrUpdateHubPickUpPoint(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setIsRedirect(true);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"
                        style={{ color: "#1e1e1e" }}
                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                                {/* form  */}

                                <PickUpPointsAddOrUpdate
                                    onSubmit={handleSubmit} setLatitude={setLatitude} setLongitide={setLongitide} address={dataInfo?.pickUpPointAddress} setMapData={setMapData}
                                    dataInfo={dataInfo} />

                            {/* </span>
                        </span> */}
                    </div>


                </ModalBody>
            </Modal>


        </div>
    );
};


export default connect((state) => ({
    rtl: state.rtl,
}))(HubPickUpPointsDetailsModal);
